import GroupedQuestionsTabNav from './GroupedQuestionsTabNav';

export default GroupedQuestionsTabNav;
